import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import ContrastRoundedIcon from '@mui/icons-material/ContrastRounded';
import { useTranslation } from 'react-i18next';
import { useThemeModeStore } from './themeModeStore';
import type { ThemeMode } from './createAppTheme';

// labelKey, nie gotowy label — tłumaczenie rozwijane przy renderze, żeby przełączenie
// języka zmieniało też tooltipy i aria-label przycisków motywu.
const OPTIONS: { value: ThemeMode; labelKey: string; icon: JSX.Element }[] = [
  { value: 'light', labelKey: 'theme.light', icon: <LightModeRoundedIcon fontSize="small" /> },
  { value: 'dark', labelKey: 'theme.dark', icon: <DarkModeRoundedIcon fontSize="small" /> },
  { value: 'high-contrast', labelKey: 'theme.highContrast', icon: <ContrastRoundedIcon fontSize="small" /> },
];

export function ThemeModeSwitcher() {
  const { t } = useTranslation();
  const { mode, setMode } = useThemeModeStore();

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      size="small"
      onChange={(_e, next: ThemeMode | null) => {
        if (next) setMode(next);
      }}
      aria-label={t('theme.modeAriaLabel')}
      sx={{
        '& .MuiToggleButton-root': {
          border: 0,
          px: 1,
          height: 32,
          minHeight: 32,
          borderRadius: 1,
          color: 'text.secondary',
          '&.Mui-selected': {
            backgroundColor: (t) => t.palette.action.selected,
            color: 'primary.main',
          },
          '&:not(:first-of-type)': { ml: 0.25 },
        },
      }}
    >
      {OPTIONS.map((opt) => {
        const label = t(opt.labelKey);
        return (
          <ToggleButton key={opt.value} value={opt.value} aria-label={label}>
            <Tooltip title={label}>{opt.icon}</Tooltip>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}
